export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const LEGALE_BASE_URL = process.env.REACT_APP_LEGALE_BASE_URL;
export const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL;
export const REMOTE_PORTAL_BASE_URL = process.env.REACT_APP_REMOTE_PORTAL_BASE_URL;
export const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_BASE_URL;

export const FIREBASE_COLLECTION_PREFIX = process.env.REACT_APP_FIREBASE_COLLECTION_PREFIX ?? "";

export const EXPLORER_FILTER_PAGE_SIZE_KEY = "explorer_filter_page_size";
export const EXPLORER_TREE_WIDTH_KEY = "explorer_tree_width";
export const EXPLORER_TREE_EXPANDED_KEYS_KEY = "explorer_tree_expanded_keys";

export const RICH_TEXT_EDITOR_API_KEY = process.env.REACT_APP_RICH_TEXT_EDITOR_API_KEY;

export const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_BASE_URL || API_BASE_URL;

export const conditionOperators = [
    { value: "eq", name: "=" },
    { value: "gt", name: ">" },
    { value: "gte", name: ">=" },
    { value: "lt", name: "<" },
    { value: "lte", name: "<=" },
    { value: "neq", name: "!=" },
    { value: "in", name: "contain" },
    { value: "nin", name: "notContain" },
    { value: "empty", name: "empty" },
    { value: "fill", name: "fill" },
];


export const smartTemplatePlugins = {
    suggestededits: {
        name: "suggestededits",
        value: "suggestededits",
        label: "review",
    },
    comments: {
        name: "comments",
        value: "comments",
        label: "comments",
    },
    revisionHistory: {
        name: "revisionHistory",
        value: "revisionHistory",
        label: "history",
    },
};
